import React from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const Alert = ({
  variant = 'info',
  header,
  onClose,
  children,
  textColor = 'text-neutral-110 dark:text-white'
}) => {
  const icons = {
    info: <InfoOutlinedIcon fontSize='small' htmlColor='#438BF7' />,
    warning: <ErrorOutlineIcon htmlColor='#FFA940' fontSize='small' />,
    alert: <ErrorOutlineIcon htmlColor='#D71D10' fontSize='small' />,
    success: <CheckCircleOutlineIcon htmlColor='#01B876' fontSize='small' />
  };

  const variantStyles = {
    info: { backgroundColor: 'bg-info', borderColor: 'border-info' },
    warning: { backgroundColor: 'bg-warning', borderColor: 'border-warning' },
    alert: { backgroundColor: 'bg-alert', borderColor: 'border-alert' },
    success: { backgroundColor: 'bg-success', borderColor: 'border-success' }
  };

  const style = variantStyles[variant];

  return (
    <div className={`w-full px-4 py-3.5 ${style.backgroundColor} bg-opacity-5 rounded-md border ${style.borderColor} flex items-center justify-between`}>
      <div className='justify-start items-center gap-4 flex'>
        {icons[variant]}
        <div className={`${textColor}  text-sm font-normal leading-5`}>{header}</div>
      </div>
      {!!onClose
        && <CloseIcon onClick={onClose} sx={{ color: 'black', cursor: 'pointer' }} fontSize='small' />
      }
      {children}
    </div>
  );
};

Alert.propTypes = {
  variant: PropTypes.oneOf(['info', 'warning', 'alert', 'success']),
  header: PropTypes.string,
  onClose: PropTypes.func,
  children: PropTypes.node
};

export default Alert;
